var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    stroke: "none",
    strokeWidth: 1.5,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.10518 3.23576L6.61095 3.07937L6.63298 2.55043C6.65241 2.08376 7.03754 1.71094 7.50936 1.71094C7.98119 1.71094 8.36632 2.08377 8.38575 2.55045L8.40777 3.07938L8.91354 3.23578C10.85 3.83457 12.2554 5.6396 12.2554 7.77093V7.81022L12.2595 7.8493L12.759 12.6027C12.8087 13.0758 13.0491 13.4368 13.2856 13.6944C13.5173 13.9468 13.7951 14.1521 13.9953 14.2997C14.1625 14.4229 14.2686 14.6187 14.2686 14.8395C14.2686 15.2094 13.9688 15.5092 13.5989 15.5092H1.41967C1.04982 15.5092 0.75 15.2094 0.75 14.8395C0.75 14.6187 0.856078 14.4229 1.02329 14.2997C1.22353 14.1521 1.50127 13.9468 1.73298 13.6944C1.96947 13.4368 2.20996 13.0758 2.25966 12.6027L2.75911 7.84931L2.76322 7.81023V7.77093C2.76322 5.63958 4.16869 3.83453 6.10518 3.23576ZM7.50933 19.7024C6.58723 19.7024 5.76677 19.2631 5.24709 18.5819H7.50933H9.77158C9.2519 19.2631 8.43143 19.7024 7.50933 19.7024Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.f9be201b573270def9e8a115ccafd5a0.svg";
export { ForwardRef as ReactComponent };